import { injectGlobal, css } from "emotion/macro"
import { color } from "../../styles/variables"

injectGlobal({
  "body.component-overlay-menu-active": {
    maxHeight: "100vh",
    overflow: "hidden",
  },
})

export const defaultClassName = css`
  padding: 15px;
  display: block;
  background-color: rgba(255, 255, 255, 0.98);
  position: absolute;
  z-index: 900;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: scroll;
  perspective: 1200;

  .icon-wrapper {
    display: none;
  }

  .item-wrapper button.item {
    position: initial;
    top: auto;
    right: auto;
    font-size: 28px;
    font-weight: 700;
    line-height: 28px;
    padding: 20px;
    transition: color 0.5s ease;
    width: 100%;

    &:hover,
    &:focus {
      color: ${color.rgb.orange[0]};
    }
  }

  nav {
    display: flex;
    flex-direction: column;
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/OverlayMenu/style.js